import { UsageFeatureProps } from '@employee-experience/common';
import { IUserProfile } from '../../models/IUserProfile';
import {
  IReceiveUserProfileAction,
  IRequestUserProfileAction,
  IRequestUserProfileFailedAction,
  UserActionTypes,
} from '../action-types/userProfileActionTypes';

export function requestUserProfile(feature: UsageFeatureProps): IRequestUserProfileAction {
  return {
    type: UserActionTypes.REQUEST_USERPROFILE,
    feature,
  };
}

export function receiveUserProfile(userProfile: IUserProfile): IReceiveUserProfileAction {
  return {
    type: UserActionTypes.RECEIVE_USERPROFILE,
    userProfile,
  };
}

export function receiveUserProfileFailed(errorMessage: string): IRequestUserProfileFailedAction {
  return {
    type: UserActionTypes.REQUEST_USERPROFILE_FAILED,
    errorMessage,
  };
}
